/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useEffect } from "react";
import $ from "jquery";
// eslint-disable-next-line import/no-unassigned-import
import "smartmenus";
import topNav from "../../../../constants/topNavItems";
import { Link, withRouter } from "react-router-dom";
import StickySearch from "../../search/sticky-search";
import { connect } from "react-redux";

const SideBar = (props) => {
	const {
		checkForStringValue,
		push,
		reset,
		location,
		clearFilters,
		getInventorySearchCriteria,
		checkForCriteriaKeys,
		persistSearch,
		content,
	} = props;

	useEffect(() => {
		$(function() {
			$("#sub-menu").smartmenus({
				subMenusSubOffsetX: 1,
				subMenusSubOffsetY: -8,
				noMouseOver: true,
			});
		});
	}, []);

	const closeNav = () => {
		var closemyslide = document.getElementById("mySidenav");
		if (closemyslide) closemyslide.classList.remove("open-side");
	};

	const topNavItems =
		content &&
		content.links.map((obj) => (
			<li key={obj.sequence}>
				<Link to={`/content?${obj.key}`}>{obj.value}</Link>
			</li>
		));

	const linkHref = "#";

	return (
		<div id="mySidenav" className="sidenav">
			<a href={linkHref} className="sidebar-overlay" onClick={() => closeNav()} />
			<nav>
				<div onClick={() => closeNav()}>
					<div className="sidebar-back text-left">
						<i className="fa fa-angle-left pr-2" aria-hidden="true"></i> Back
					</div>
				</div>
				{/*Vertical Menu*/}
				<ul id="sub-menu" className="sm pixelstrap sm-vertical header-dropdown">
					{topNavItems}
					<li>
						<Link to={`/info-center`}>Information</Link>
					</li>
					<li className="padding-right-10 padding-left-10">
						<StickySearch
							{...{
								push,
								reset,
								location,
								clearFilters,
								getInventorySearchCriteria,
								checkForCriteriaKeys,
								persistSearch,
								checkForStringValue,
							}}
						/>
					</li>
				</ul>
			</nav>
		</div>
	);
};

const mapStateToProps = (state) => ({
	content: state.authorization.content,
});

export default connect(mapStateToProps, null)(withRouter(SideBar));
